module.exports = __webpack_public_path__ + "static/media/bg-03.57134738.png";